import React, { Component } from 'react';
import UtilService from '../../services/util.service';
import BotType from '../../enums/BotType';
import globalStoreService from '../../services/global-store.service';

const switchAccountMessageComponent = ({ message, messageTime, showNumbersToSwitchBot, hide_logo, fromHistory }) => {

    return (
        <div>
            <span className={(globalStoreService.get("currentBotType") === BotType.PAYMENTS_BANK) ? "arya new paymentsbank" : "arya new"} style={{ visibility: (hide_logo) ? 'hidden' : 'visible' }}>
            </span>
            <ul className="bubbles relate">
                {message && <div>
                    <li>
                        <p>Hey! It seems like you have a {message} related query.
                        <button
                                disabled={(fromHistory) ? true : false}
                                className="cursor-pointer link-color switch_msg_btn" onClick={() => {
                                    // open the switch account menu to with switch tab open for user to switch account
                                    showNumbersToSwitchBot();
                                }}>Click here</button> to switch to a {message} number from your profile.</p>
                        <span className="time">{messageTime && messageTime.time_in_format}</span>
                    </li>
                </div>}
            </ul>

        </div>

    )
}

export default switchAccountMessageComponent



// WEBPACK FOOTER //
// ./src/components/message-components/switch-account-message.component.js